module.exports = __webpack_public_path__ + "media/red_cross.396f6209.webm";